/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-05-08 17:05:46
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-05-09 17:13:19
 * @FilePath: \zeelool-nextjs\src\components\Layout\Header\CountDown.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useTranslations } from '@/i18n/use-translations';
import { useEffect, useState } from 'react';

// TODO:是否可以和components/CountDown.tsx合并？
interface CountDownProps {
  time: number;
  textColor?: string;
  numberColor?: string;
  onCountDownEnd?: () => void;
}

interface CountDownLayoutProps {
  rootClassName: string;
  numberClassName: string;
}

const CountDown = ({
  time = 0,
  textColor = '#282828',
  numberColor = '#282828',
  onCountDownEnd,
  rootClassName,
  numberClassName,
}: CountDownProps & CountDownLayoutProps) => {
  const [remainingSeconds, setRemainingSeconds] = useState(() => Math.max(0, Math.ceil(time)));
  const t = useTranslations('layout.header');

  useEffect(() => {
    const initialSeconds = Math.max(0, Math.ceil(time));
    setRemainingSeconds(initialSeconds);
    if (initialSeconds === 0) {
      onCountDownEnd?.();
      return;
    }

    const timer = window.setInterval(() => {
      setRemainingSeconds((currentSeconds) => {
        if (currentSeconds <= 1) {
          window.clearInterval(timer);
          onCountDownEnd?.();
          return 0;
        }
        return currentSeconds - 1;
      });
    }, 1000);

    return () => window.clearInterval(timer);
  }, [onCountDownEnd, time]);

  const day = Math.floor(remainingSeconds / (60 * 60 * 24));
  const hour = Math.floor((remainingSeconds / (60 * 60)) % 24);
  const minute = Math.floor((remainingSeconds / 60) % 60);
  const second = Math.floor(remainingSeconds % 60);

  return (
    <div className={`flex items-center justify-center font-fb ${rootClassName}`}>
      {day > 0 && (
        <span className="mr-[5px] whitespace-nowrap">
          <span style={{ color: numberColor }}>{day}</span>{' '}
          <span style={{ color: textColor }}>{day > 1 ? t('days') : t('day')}</span>
        </span>
      )}
      <span className={`text-center ${numberClassName}`} style={{ color: numberColor }}>
        {hour.toString().padStart(2, '0')}
      </span>
      <span style={{ color: textColor }}>:</span>
      <span className={`text-center ${numberClassName}`} style={{ color: numberColor }}>
        {minute.toString().padStart(2, '0')}
      </span>
      <span style={{ color: textColor }}>:</span>
      <span className={`text-center ${numberClassName}`} style={{ color: numberColor }}>
        {second.toString().padStart(2, '0')}
      </span>
    </div>
  );
};

export const PcTopBarCountDown = (props: CountDownProps) => (
  <CountDown {...props} rootClassName="text-[12px] lg:ml-[72px]" numberClassName="min-w-[20px]" />
);

export const WapTopBarCountDown = (props: CountDownProps) => (
  <CountDown {...props} rootClassName="text-[3.2vw]" numberClassName="min-w-[4.267vw]" />
);
